export default "__VITE_ASSET__CcsUqoZV__"